/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AccountEnabledPatchForm } from '../model/models';
import { CassiereBackofficeListFilter } from '../model/models';
import { EsercenteCassiereStatoAccountEsitoDTO } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelCassiereBackofficeRowDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AvviaResetPasswordCassiereRequestParams {
    userId: string;
}

export interface ForzaStatoAccountCassiereRequestParams {
    userId: string;
    accountEnabledPatchForm: AccountEnabledPatchForm;
}

export interface ListCassieriRequestParams {
    filter: CassiereBackofficeListFilter;
    pageable: Pageable;
}


export interface CassieriServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Avvia il reset password per un cassiere (SUPERADMIN).
     * Riusa resetUserPassword (invia l\&#39;email col doppio link). 404 privacy se target non CASSIERE; 400 se il cassiere non ha email o e\&#39; bloccato dall\&#39;amministrazione; 422 se il cassiere non ha un\&#39;impresa risolvibile (nessuna riga UserNegozio: non si conosce il proprietario).
     * @endpoint post /api/v1/gestione/cassieri/{user_id}/reset-password
* @param requestParameters
     */
    avviaResetPasswordCassiere(requestParameters: AvviaResetPasswordCassiereRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Blocca/abilita l\&#39;accesso di un cassiere (SUPERADMIN).
     * Scrive la sentinella di blocco amministrativo reale + Keycloak, in una sola transazione fail-fast. Su blocco tenta la revoca delle sessioni attive (best-effort, esito nel campo sessioni_revocate). 404 privacy se target non CASSIERE; 409 se anonimizzato; 422 se senza impresa risolvibile (D12).
     * @endpoint put /api/v1/gestione/cassieri/{user_id}/stato-account
* @param requestParameters
     */
    forzaStatoAccountCassiere(requestParameters: ForzaStatoAccountCassiereRequestParams, extraHttpRequestParams?: any): Observable<EsercenteCassiereStatoAccountEsitoDTO>;

    /**
     * Lista paginata dei cassieri (SUPERADMIN).
     * Filtri opzionali: q (email/nome/cognome), stato. Default sort: email ASC, size 20. Solo \&#39;email\&#39; e\&#39; ordinabile: ogni altro valore di sort ritorna 400. Lista globale. Un cassiere con zero imprese assegnate compare comunque (imprese: []), un titolare-cassiere compare anche in questa lista (ruoli lo dichiara).
     * @endpoint get /api/v1/gestione/cassieri
* @param requestParameters
     */
    listCassieri(requestParameters: ListCassieriRequestParams, extraHttpRequestParams?: any): Observable<PagedModelCassiereBackofficeRowDTO>;

}
